<template>
  <b-layout :colors="$site.colors" header-title="Online Booking Disabled" :header-back-route="homeRoute">
    <b-container class="mt-12">
      <h4 class="text-center text-primary font-semibold mb-3">
        {{ $t('pages.widget.disabled.title') }}
      </h4>
      <p class="text-center text-secondary text-sm">
        {{ $t('pages.widget.disabled.message', { location: businessName }) }}
      </p>
    </b-container>
  </b-layout>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()

definePageMeta({
  middleware: ['widget']
})

const homeRoute = computed(() => {
  const locationStore = useLocationStore()

  return locationStore?.homeRoute || { path: '/' }
})

const businessName = computed(() => {
  if ($site.tabs.contact && $site.tabs.contact.business) {
    return $site.tabs.contact.business
  } else {
    return $site.location.title
  }
})

</script>
